import { Map } from 'immutable';
import {
  types as jobTypes,
  records as jobRecords,
} from '@saucelabs/sl-module-jobs';
import {
  types as buildsTypes,
  records as buildsRecords,
} from '@saucelabs/sl-module-builds';

import { INITIALIZE, UPDATE } from './types';
import { buildTypes as buildsV2Types } from './../build/types';

const initialState = Map({
  job: new jobRecords.JobRecord(),
  build: new buildsRecords.BuildRecord(),
  loading: true,
  pageIndex: 0,
  shouldCallInit: true,
});

const containerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case INITIALIZE.REQUEST:
      return state.set('loading', true);
    case INITIALIZE.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('loading', false);
      });
    case INITIALIZE.FAILURE:
      return state.set('loading', false);
    case UPDATE.PAGE_INDEX:
      return state.set('pageIndex', payload);
    case UPDATE.SHOULD_CALL_INIT:
      return state.set('shouldCallInit', payload);
    case jobTypes.JOB_GET.SUCCESS:
      return state.set('job', new jobRecords.JobRecord(payload));
    case buildsTypes.BUILD_GET_BY_NAME.SUCCESS:
      return state.set('build', new buildsRecords.BuildRecord(payload));
    case buildsV2Types.GET_BUILD_BY_JOB_ID.SUCCESS:
      return state.set('build', new buildsRecords.BuildRecord({
        ...payload,
        isBuildsV2: true,
      }));
    case jobTypes.UP_JOB_GET.SUCCESS:
      return state.set('job', new jobRecords.RdcJobRecord(payload));
    default:
      return state;
  }
};

export default containerReducer;
export { initialState };
